import { Area } from '@/enums/Area.enum';
import { LayerName } from '@/enums/LayerName.enum';
import { MapView } from '@/enums/MapView.enum';
import Control from 'ol/control/Control';
import Layer from 'ol/layer/WebGLTile.js';
import Google from 'ol/source/Google.js';
import googleMapsLogoOutline from '@/assets/images/google-maps-logo-outline.png';


// Hardcoded Google Maps API key
const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;

const BASE_GOOGLE_LAYER_OPTIONS = {
  key: GOOGLE_MAPS_API_KEY,
  scale: 'scaleFactor2x',
  highDpi: true,
  layerTypes: ['layerRoadmap'],
};

export const googleLayer = new Layer({
  source: new Google({
    ...BASE_GOOGLE_LAYER_OPTIONS,
  }) as any,
});

googleLayer.setProperties({ area: Area.GOOGLE, name: LayerName.GOOGLE });

export const changeGoogleLayerView = (viewType: MapView): void => {
  googleLayer.setSource(
    new Google({
      ...BASE_GOOGLE_LAYER_OPTIONS,
      mapType: viewType.toLowerCase(),
    }) as any
  );
};

export class GoogleLogoControl extends Control {
  private logoElement: HTMLImageElement;

  constructor() {
    const element = document.createElement('img');
    element.style.pointerEvents = 'none';
    element.style.position = 'absolute';
    element.style.bottom = '28px';
    element.style.right = '28px';
    element.style.height = '20px';
    element.style.display = 'none';
    element.src = googleMapsLogoOutline;
    super({
      element: element,
    });
    this.logoElement = element;
  }

  setVisible(visible: boolean): void {
    this.logoElement.style.display = visible ? 'block' : 'none';
  }
}
